import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { Icon } from "components/icon/Icon";

export const StyledName = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  margin: 0;
  margin-left: 8px;
  text-overflow: ellipsis;
  max-width: 90%;
  overflow: hidden;
`;

export const StyledImage = styled.img`
  border-radius: 4px;
  width: 24px;
  height: 24px;
  background-color: var(${DesignToken.SurfaceSecondaryDefault});
`;

export const StyledImageWithDiv = styled.div`
  border-radius: 4px;
  width: 24px;
  height: 24px;
  background-color: var(${DesignToken.SurfaceSecondaryDefault});
`;

export const StyledIcon = styled(Icon)`
  fill: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.headerColor
  };
  cursor: pointer;
`;
